"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const react_router_dom_1 = require("react-router-dom");
const moment_1 = __importDefault(require("moment"));
const PaymentBookingStyle_1 = require("./PaymentBookingStyle");
const users_1 = require("../../utils/users");
const RoutesPaths_1 = require("../../routes/RoutesPaths");
const helpers_1 = require("../../utils/helpers");
const response_codes_1 = require("../../assets/constants/response_codes");
const HeaderMenuComponent_1 = __importDefault(require("../../components/headerMenuComponent/HeaderMenuComponent"));
const detectDevice_1 = __importDefault(require("../../utils/detectDevice"));
const HomeFooter_1 = __importDefault(require("../home/homeFooter/HomeFooter"));
const message_utils_1 = __importDefault(require("../../utils/message_utils"));
const FormSuite_1 = __importDefault(require("../../hooks/FormSuite"));
const PaymentStyled_1 = require("./payment/PaymentStyled");
const Index_1 = __importDefault(require("../../components/shared/Input/Index"));
const VehicleForm_1 = __importDefault(require("../../components/suiteCollapse/suiteForm/VehicleForm"));
const CheckinRequestBuilder_1 = __importDefault(require("../../dtos/builder/CheckinRequestBuilder"));
const CheckinService_1 = __importDefault(require("../../services/CheckinService"));
const CheckinData_1 = __importDefault(require("../../hooks/CheckinData"));
const AbstractCheckin_1 = __importDefault(require("./abstractCheckin/AbstractCheckin"));
require("./CheckIn.scss");
const useHubspot_1 = __importDefault(require("../../utils/useHubspot"));
const CheckInCheckOut_1 = __importDefault(require("../../components/checkInCheckOut/CheckInCheckOut"));
const PerfilStyles_1 = require("../accountInfo/perfil/PerfilStyles");
const user_requests_1 = require("../../dataSource/user_requests");
const BookingReason_1 = __importDefault(require("../../components/suiteCollapse/suiteForm/bookingReason/BookingReason"));
const SuiteTabsPreChekin_1 = __importDefault(require("../../components/suiteCollapse/suiteTabPreCheckin/SuiteTabsPreChekin"));
const Properties_1 = require("../../hooks/Properties");
const constants_1 = require("../../assets/constants/constants");
const CheckIn = () => {
    const arrayID = ['1'];
    const { isMobile } = (0, detectDevice_1.default)(992);
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [formCheckIn] = antd_1.Form.useForm();
    const [userLogged, setUserLogged] = (0, react_1.useState)(null);
    const [userEmail, setUserEmail] = (0, react_1.useState)(undefined);
    const [reservedata, loadedData] = (0, CheckinData_1.default)();
    const [vehicleIsRequired, setVehicleIsRequired] = (0, react_1.useState)(false);
    const { dispatch } = (0, useHubspot_1.default)();
    const [guestsQty, setGuestsQty] = (0, react_1.useState)(1);
    const propertyContext = (0, Properties_1.useProperties)();
    const [propInfo, setPropInfo] = (0, react_1.useState)({});
    const [requiredGuests, setRequiredGuests] = (0, react_1.useState)(Array(guestsQty - 1).fill(false));
    const [tabActive, setTabActive] = (0, react_1.useState)('0');
    const [isUpdate, setIsUpdate] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        setRequiredGuests(Array(guestsQty - 1).fill(false));
    }, [guestsQty]);
    const getPropertyInfo = (0, react_1.useCallback)((propId) => {
        var _a;
        let prop;
        if (propertyContext === null || propertyContext === void 0 ? void 0 : propertyContext.properties) {
            prop = (_a = propertyContext === null || propertyContext === void 0 ? void 0 : propertyContext.properties) === null || _a === void 0 ? void 0 : _a.find(property => property.propId.toString() === propId);
        }
        return prop;
    }, [propertyContext.properties]);
    (0, react_1.useEffect)(() => {
        if (reservedata && reservedata.propId) {
            const propertyInfo = getPropertyInfo(reservedata.propId);
            setPropInfo(propertyInfo || {});
        }
    }, [reservedata, getPropertyInfo]);
    const validateFields = (tmpForm, fields, changeRequiredFunction, formKey) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const key = 0;
            const someFieldsIsNotEmpty = fields.some((tmpField) => {
                return !!tmpForm.getFieldValue([formKey, key, tmpField]);
            });
            const allFieldsIsComplete = fields.every((tmpField) => tmpForm.getFieldValue([formKey, key, tmpField]));
            if (someFieldsIsNotEmpty && !allFieldsIsComplete) {
                changeRequiredFunction(true);
            }
            tmpForm
                .validateFields(fields.map((field) => [formKey, key, field]))
                .then(() => {
                resolve(true);
            })
                .catch(error => {
                if (error.errorFields.length > 0) {
                    reject(error);
                }
                else
                    resolve(true);
            });
        });
    });
    (0, react_1.useEffect)(() => {
        document.title = `360 Suítes - Check-in`;
    }, []);
    (0, react_1.useEffect)(() => {
        if (!(0, users_1.checkUserIsAuth)() || !(0, users_1.checkUserTokenIsValid)()) {
            const lastUrl = location.pathname + location.search;
            (0, users_1.setLastPageBeforeLogin)(lastUrl);
            history.push(RoutesPaths_1.routesPaths.register);
        }
    }, [history, location, formCheckIn]);
    (0, react_1.useEffect)(() => {
        const token = (0, users_1.getAccessToken)();
        setUserLogged(token);
    }, [formCheckIn]);
    (0, react_1.useEffect)(() => {
        if (userLogged) {
            const userData = (0, users_1.getUserData)();
            const tmpOffers = [];
            userData.emailOffers && tmpOffers.push('email');
            userData.allowStoreData && tmpOffers.push('allowStore');
            if (userData.email) {
                setUserEmail(userData.email);
                const formValues = formCheckIn.getFieldsValue();
                if (formValues.checkin && formValues.checkin.length > 0) {
                    const checkin = formValues.checkin.map((v) => {
                        var _a;
                        const birthDate = userData.birthDate ? (0, moment_1.default)(userData.birthDate, 'yyyy-MM-DD').format('DD/MM/yyyy') : '';
                        let ddiRequired;
                        let phoneRequired;
                        const telephone = (userData === null || userData === void 0 ? void 0 : userData.telephone) ? (_a = userData === null || userData === void 0 ? void 0 : userData.telephone) === null || _a === void 0 ? void 0 : _a.split('#') : [];
                        if (telephone.length === 2) {
                            [ddiRequired, phoneRequired] = telephone;
                        }
                        else {
                            ddiRequired = '55';
                            phoneRequired = (userData === null || userData === void 0 ? void 0 : userData.telephone) ? userData === null || userData === void 0 ? void 0 : userData.telephone.replace(/\D/g, '') : '';
                        }
                        return Object.assign(Object.assign({}, v), { fullnameRequired: `${userData.firstName} ${userData.lastName}`, birthdayRequired: birthDate, ddiRequired,
                            phoneRequired, emailRequired: userData.email });
                    });
                    formCheckIn.setFieldsValue(Object.assign(Object.assign({}, formValues), { checkin, acceptStoreData: userData.allowStoreData, acceptOffers: userData.emailOffers, requiredCheckbox: true }));
                }
            }
        }
    }, [formCheckIn, userLogged]);
    (0, react_1.useEffect)(() => {
        if (reservedata.guestsQtyString) {
            setGuestsQty(Number(reservedata.guestsQtyString));
        }
        if (reservedata && reservedata.infoPreCheckIn) {
            setIsUpdate(true);
            const infoPreCheckinJSON = JSON.parse(reservedata.infoPreCheckIn);
            const formValues = formCheckIn.getFieldsValue();
            if (formValues.checkin && formValues.checkin.length > 0) {
                const checkin = formValues.checkin.map((v) => {
                    var _a, _b, _c, _d;
                    const birthDate = infoPreCheckinJSON.birthday
                        ? (0, moment_1.default)(infoPreCheckinJSON.birthday, constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL).format(constants_1.DEFAULT_FORMAT_DATE_PT_BR)
                        : '';
                    const ddiRequired = infoPreCheckinJSON.ddi;
                    const phoneRequired = infoPreCheckinJSON.phone.length > 11
                        ? infoPreCheckinJSON.phone.replace(ddiRequired, '')
                        : infoPreCheckinJSON.phone;
                    const [addressName, addressNumber, addressComplement, addressDistrict] = infoPreCheckinJSON.address.fullAddress.split('\n');
                    const brandColor = (((_a = reservedata.vehicles) === null || _a === void 0 ? void 0 : _a[0].model.includes('-'))
                        ? (_b = reservedata.vehicles) === null || _b === void 0 ? void 0 : _b[0].model.split('-')
                        : (_c = reservedata.vehicles) === null || _c === void 0 ? void 0 : _c[0].model.split(' ')) || [];
                    const vehiclePlate = (_d = reservedata.vehicles) === null || _d === void 0 ? void 0 : _d[0].plate;
                    const typePlate = vehiclePlate && vehiclePlate.trim().length === 7 ? 'mercosul' : 'default';
                    const [checkInTimeAux, checkOutTimeAux] = reservedata.guest2Annotations
                        ? reservedata.guest2Annotations.split('|')
                        : '';
                    const checkInTime = checkInTimeAux.replace('Check-in: ', '');
                    const checkOutTime = checkOutTimeAux.replace('Check-out: ', '');
                    let guestsList = [...infoPreCheckinJSON.guests];
                    if (infoPreCheckinJSON.visitors) {
                        guestsList = [...guestsList, ...infoPreCheckinJSON.visitors];
                    }
                    const guestDataFields = guestsList.map((guest, index) => {
                        const birtDayGuest = (0, moment_1.default)(guest.birthday, constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL);
                        const ddiGuest = guest.ddi ? guest.ddi : '55';
                        const phoneGuest = guest.phone.length > 11 ? guest.phone.replace(ddiRequired, '') : guest.phone;
                        return {
                            id: index,
                            fullname: guest.name ? guest.name : '',
                            documentTypeGuest: guest.docType ? guest.docType : 'CPF',
                            documentGuest: guest.doc ? guest.doc : '',
                            birthday: birtDayGuest.isValid() ? birtDayGuest.format(constants_1.DEFAULT_FORMAT_DATE_PT_BR) : '',
                            email: guest.email ? guest.email : '',
                            ddi: ddiGuest,
                            phone: phoneGuest,
                        };
                    });
                    const guestsEmpty = Array(Number(reservedata.guestsQtyString) - guestsList.length - 1)
                        .fill(0)
                        .map((id, index) => ({
                        id: index + infoPreCheckinJSON.guests.length,
                        fullname: '',
                        documentTypeGuest: 'CPF',
                        documentGuest: '',
                        birthday: '',
                        email: '',
                        ddi: '55',
                        phone: '',
                    }));
                    if (guestsEmpty.length > 0)
                        guestDataFields.push(...guestsEmpty);
                    return Object.assign(Object.assign({}, v), { fullnameRequired: infoPreCheckinJSON.name, birthdayRequired: birthDate, ddiRequired,
                        phoneRequired, documentTypeGuestRequired: infoPreCheckinJSON.docType ? infoPreCheckinJSON.docType : 'CPF', documentGuestRequired: infoPreCheckinJSON.doc, addressCep: infoPreCheckinJSON.address.zip, addressName: (0, helpers_1.myTrim)(addressName), addressNumber: (0, helpers_1.myTrim)(addressNumber), addressComplement: (0, helpers_1.myTrim)(addressComplement), addressDistrict: (0, helpers_1.myTrim)(addressDistrict), addressCity: infoPreCheckinJSON.address.city, addressState: infoPreCheckinJSON.address.state, country: infoPreCheckinJSON.address.country, emailRequired: infoPreCheckinJSON.address.email || infoPreCheckinJSON.email, guests: guestDataFields, vehicleBrand: `${(brandColor === null || brandColor === void 0 ? void 0 : brandColor[0]) || ''}${(brandColor === null || brandColor === void 0 ? void 0 : brandColor.length) > 2 ? brandColor === null || brandColor === void 0 ? void 0 : brandColor[1] : ''}`, vehicleColor: (brandColor === null || brandColor === void 0 ? void 0 : brandColor[brandColor.length - 1]) || '', vehiclePlate: vehiclePlate ? vehiclePlate.trim() : '', vechiclePlateType: typePlate, checkInTime,
                        checkOutTime, hostingWork: infoPreCheckinJSON.hostingWork, hostingPurchases: infoPreCheckinJSON.hostingPurchases, hostingTourism: infoPreCheckinJSON.hostingTourism, hostingPrivacy: infoPreCheckinJSON.hostingPrivacy });
                });
                formCheckIn.setFieldsValue(Object.assign(Object.assign({}, formValues), { checkin }));
                Array(guestsQty - 1)
                    .fill(0)
                    .forEach(fieldKey => {
                    const guests = formCheckIn.getFieldValue(['checkin', fieldKey, 'guests']);
                    const guestFieldsToValidate = ['fullname', 'documentGuest', 'birthday', 'email', 'phone'];
                    const requiredGuestsValidation = guests.map((guest, index) => {
                        return guestFieldsToValidate.some(fieldName => {
                            return (0, helpers_1.myTrim)(formCheckIn.getFieldValue(['checkin', fieldKey, 'guests', index, fieldName]));
                        });
                    });
                    setRequiredGuests(requiredGuestsValidation);
                });
            }
        }
        if (reservedata.guestsQtyString && !reservedata.infoPreCheckIn) {
            const formValues = formCheckIn.getFieldsValue();
            if (formValues.checkin[0].guests.length - 1 !== Number(reservedata.dailyQtyString)) {
                const guestsEmpty = [];
                new Array(Number(reservedata.guestsQtyString) - 1).fill(0).forEach((_, id) => {
                    var _a;
                    if (!((_a = formValues.checkin[0].guests[id]) === null || _a === void 0 ? void 0 : _a.fullname))
                        guestsEmpty.push({
                            id: id + 1,
                            fullname: '',
                            documentTypeGuest: 'CPF',
                            documentGuest: '',
                            birthday: '',
                            email: '',
                            ddi: '55',
                            phone: '',
                        });
                    else
                        guestsEmpty.push(Object.assign(Object.assign({}, formValues.checkin[0].guests[id]), { id: id + 1 }));
                });
                formValues.checkin[0].guests = guestsEmpty;
                formCheckIn.setFieldsValue(formValues);
            }
        }
    }, [reservedata, formCheckIn, guestsQty]);
    (0, react_1.useEffect)(() => {
        if (loadedData) {
            setIsLoading(false);
        }
    }, [loadedData]);
    function setRequiredGuest(key, value) {
        setRequiredGuests(requiredGuests.map((isRequired, index) => (key === index ? value : isRequired)));
    }
    const onFinish = () => __awaiter(void 0, void 0, void 0, function* () {
        const key = 0;
        const formValues = formCheckIn.getFieldsValue();
        formValues.checkin = formValues.checkin.map((values) => (Object.assign(Object.assign({}, values), { fullnameRequired: values.fullnameRequired.trim().replaceAll(/\s{2,}/g, ' ') })));
        formValues.guests = formValues.checkin[key].guests.map((values) => (Object.assign(Object.assign({}, values), { fullname: values.fullname.trim().replaceAll(/\s{2,}/g, ' ') })));
        formCheckIn.setFieldsValue(formValues);
        const checkinUserValidation = new Promise((resolve, reject) => {
            const userFields = [
                'fullnameRequired',
                'birthdayRequired',
                'ddiRequired',
                'phoneRequired',
                'documentGuestRequired',
                'country',
                'addressCity',
                'addressName',
                'addressNumber',
                'addressState',
                'addressCep',
                'addressDistrict',
                'bookingReason',
            ];
            validateFields(formCheckIn, userFields, () => { }, 'checkin')
                .then(() => {
                resolve(true);
            })
                .catch(error => reject(error));
        });
        const checkinGuestValidation = new Promise((resolve, reject) => {
            const guestsQtdWithoutUser = guestsQty - 1;
            if (guestsQtdWithoutUser === 0)
                resolve(true);
            Array(guestsQtdWithoutUser)
                .fill(0)
                .forEach(fieldKey => {
                const guests = formCheckIn.getFieldValue(['checkin', fieldKey, 'guests']);
                const guestFieldsToValidate = ['fullname', 'documentGuest', 'birthday', 'email', 'phone'];
                const requiredGuestsValidation = guests.map((guest, index) => {
                    return guestFieldsToValidate.some(fieldName => {
                        return (0, helpers_1.myTrim)(formCheckIn.getFieldValue(['checkin', fieldKey, 'guests', index, fieldName]));
                    });
                });
                setRequiredGuests(requiredGuestsValidation);
                const totalNotEmpty = requiredGuestsValidation.reduce((total, value) => (value ? total + 1 : total), 0);
                if (totalNotEmpty > 0) {
                    formCheckIn
                        .validateFields([
                        ...guests.reduce((arrayTotal, guest, index) => [
                            ...arrayTotal,
                            ...guestFieldsToValidate.map(fieldName => ['checkin', fieldKey, 'guests', index, fieldName]),
                        ], []),
                    ])
                        .then(() => {
                        resolve(true);
                    })
                        .catch((error) => {
                        if (error.errorFields && error.errorFields.length > 0) {
                            reject(error);
                        }
                        resolve(true);
                    });
                }
                else {
                    resolve(true);
                }
            });
        });
        const checkboxValidate = new Promise((resolve, reject) => {
            const guestFields = ['acceptStoreData', 'requiredCheckbox'];
            const someNotChecked = guestFields.some(field => !formCheckIn.getFieldValue(field));
            if (someNotChecked)
                formCheckIn
                    .validateFields()
                    .then(() => {
                    resolve(true);
                })
                    .catch((error) => reject(error));
            else
                resolve(true);
        });
        const checkinVehicleValidation = new Promise((resolve, reject) => {
            const vehicleFields = ['vehiclePlate', 'vehicleBrand', 'vehicleColor'];
            validateFields(formCheckIn, vehicleFields, setVehicleIsRequired, 'checkin')
                .then(() => {
                resolve(true);
            })
                .catch(error => reject(error));
        });
        const checkinFieldsValidation = new Promise((resolve, reject) => {
            const checkinFields = ['checkInTime', 'checkOutTime'];
            validateFields(formCheckIn, checkinFields, () => { }, 'checkin')
                .then(() => {
                resolve(true);
            })
                .catch(error => reject(error));
        });
        yield Promise.all([
            checkinUserValidation,
            checkinGuestValidation,
            checkinVehicleValidation,
            checkinFieldsValidation,
            checkboxValidate,
        ])
            .then(() => {
            setIsLoading(true);
            const precheckinParams = CheckinRequestBuilder_1.default.putCheckinRequest({
                bookId: reservedata.checkinData,
                propId: reservedata.propId,
                formValues,
                confirmValues: reservedata,
                key,
            });
            const hubspotParams = CheckinRequestBuilder_1.default.hubspotFormBuilder({
                formValues,
                key,
                pageName: isUpdate ? 'updateCheckin' : 'Checkin',
                pageUri: window.location.href,
                reservedata,
                propInfo,
            });
            dispatch(hubspotParams);
            CheckinService_1.default.putPreCheckin(precheckinParams)
                .then((resp) => __awaiter(void 0, void 0, void 0, function* () {
                const politics = {
                    allowStore: formCheckIn.getFieldValue('acceptStoreData') || false,
                    emailOffers: formCheckIn.getFieldValue('acceptOffers') || false,
                };
                yield (0, user_requests_1.editMyPolitics)(politics);
                setIsLoading(false);
                if (resp.code === response_codes_1.PreCheckin.success) {
                    message_utils_1.default.success({ message: `Check-in ${isUpdate ? 'atualizado' : 'realizado'} com sucesso.` });
                    setTimeout(() => {
                        history.push(`${RoutesPaths_1.routesPaths.myAccount}${RoutesPaths_1.routesPaths.myReservesSubLink}`);
                    }, 700);
                }
                setIsLoading(false);
            }))
                .catch(err => {
                setIsLoading(false);
                if (err.code === response_codes_1.PreCheckin.error) {
                    message_utils_1.default.error({
                        message: 'Não foi possível realizar o check-in no momento. Tente novamente mais tarde.',
                    });
                }
                else {
                    message_utils_1.default.error({
                        message: 'Opss não foi possível salvar os dados do check-in, por favor não feche a tela e tente novamente em 1 minuto, basta clicar no botão "Efetuar Pré Check-in"',
                        duration: 7,
                    });
                }
            });
        })
            .catch(error => {
            const descriptionElement = (0, helpers_1.messageErrorsValidationsFieldsCheckin)(error);
            const tabActiveError = (0, helpers_1.getTabActiveGuestError)(error);
            if (tabActiveError) {
                setTabActive('');
                setTabActive(tabActiveError);
            }
            message_utils_1.default.error({
                message: descriptionElement,
            });
        });
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HeaderMenuComponent_1.default, null),
        react_1.default.createElement(antd_1.Spin, { spinning: isLoading, size: "large", style: { position: 'fixed' } },
            react_1.default.createElement(FormSuite_1.default, { customForm: formCheckIn },
                react_1.default.createElement(PaymentBookingStyle_1.ContainerBody, { className: "CheckIn" },
                    react_1.default.createElement(antd_1.Col, { span: isMobile ? 24 : 8 },
                        react_1.default.createElement(AbstractCheckin_1.default, { checkinReserveData: reservedata, propInfo: propInfo })),
                    react_1.default.createElement(antd_1.Col, { span: isMobile ? 24 : 16 },
                        react_1.default.createElement(antd_1.Form, { form: formCheckIn, name: "checkin", initialValues: {
                                checkin: arrayID.map(id => ({
                                    id,
                                    guests: Array(guestsQty - 1)
                                        .fill(0)
                                        .map((id, index) => ({
                                        id: index,
                                    })),
                                })),
                            } },
                            react_1.default.createElement(PaymentStyled_1.SubTitle, { style: { marginTop: '25px' }, level: 4 }, "Finalize seu Check-in"),
                            react_1.default.createElement("span", null,
                                "Preencha o formul\u00E1rio para efetuar o pr\u00E9 check-in\u00A0",
                                reservedata.checkinData && `da reserva ${reservedata.checkinData}`),
                            react_1.default.createElement(antd_1.Col, { xs: {
                                    span: 24,
                                    flex: '1',
                                }, sm: {
                                    span: 24,
                                    flex: '1',
                                }, lg: {
                                    span: 7,
                                } },
                                react_1.default.createElement(antd_1.Form.Item, { label: "Email", labelCol: { span: 24 }, style: { color: '#c31c4a', fontWeight: 500 } },
                                    react_1.default.createElement(Index_1.default, { disabled: true, placeholder: "E-mail para contato", value: userEmail, id: "email", name: "email" }))),
                            react_1.default.createElement(antd_1.Form.List, { name: "checkin" }, fields => (react_1.default.createElement(react_1.default.Fragment, null, fields.length > 0 &&
                                fields.map((field, index) => (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(antd_1.Divider, null),
                                    react_1.default.createElement(SuiteTabsPreChekin_1.default, { key: field.key, formKey: "checkin", form: formCheckIn, field: field, requiredGuestsCheckin: requiredGuests, setIsRequiredCheckin: setRequiredGuest, tabActive: tabActive, guestsQty: guestsQty }),
                                    react_1.default.createElement(CheckInCheckOut_1.default, { formKey: "checkin", field: field }),
                                    react_1.default.createElement(VehicleForm_1.default, { field: field, formKey: "checkin", parkingIsIncluded: reservedata.parkingIncluded, vehicleIsRequired: vehicleIsRequired, setVehicleIsRequired: setVehicleIsRequired }))))))),
                            react_1.default.createElement(BookingReason_1.default, { formKey: "checkin" }),
                            react_1.default.createElement(PaymentStyled_1.SubTitle, { style: { marginTop: '25px' }, level: 4 }, "Termo de Uso"),
                            react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                                react_1.default.createElement(antd_1.Col, { span: 16 },
                                    react_1.default.createElement(PerfilStyles_1.FormItemFormulary, { valuePropName: "checked", name: "requiredCheckbox", rules: [
                                            {
                                                required: true,
                                                validator: (_, value) => value ? Promise.resolve() : Promise.reject(Error('Aceite os termos de uso.')),
                                            },
                                        ] },
                                        react_1.default.createElement(PerfilStyles_1.CheckboxStyled, null,
                                            react_1.default.createElement("div", null,
                                                react_1.default.createElement("span", null, "Li e aceito as condi\u00E7\u00F5es da \u00A0"),
                                                react_1.default.createElement(react_router_dom_1.Link, { to: {
                                                        pathname: RoutesPaths_1.routesPaths.privacy,
                                                        state: { from: RoutesPaths_1.routesPaths.paymentBooking },
                                                    } }, "pol\u00EDtica de privacidade,"),
                                                "\u00A0",
                                                react_1.default.createElement(react_router_dom_1.Link, { to: {
                                                        pathname: RoutesPaths_1.routesPaths.cancel,
                                                        state: { from: RoutesPaths_1.routesPaths.paymentBooking },
                                                    } }, "pol\u00EDtica de cancelamento,"),
                                                "\u00A0",
                                                react_1.default.createElement(react_router_dom_1.Link, { to: {
                                                        pathname: RoutesPaths_1.routesPaths.terms,
                                                        state: { from: RoutesPaths_1.routesPaths.paymentBooking },
                                                    } }, "termos de uso")))),
                                    react_1.default.createElement(PerfilStyles_1.FormItemFormulary, { valuePropName: "checked", name: "acceptOffers" },
                                        react_1.default.createElement(PerfilStyles_1.CheckboxStyled, null, "Quero receber ofertas, promo\u00E7\u00F5es exclusivas, cupons e novidades por e-mail.")),
                                    react_1.default.createElement(PerfilStyles_1.FormItemFormulary, { valuePropName: "checked", name: "acceptStoreData", rules: [
                                            {
                                                required: true,
                                                validator: (_, value) => value ? Promise.resolve() : Promise.reject(Error('Permita que a 360 processe seus dados')),
                                            },
                                        ] },
                                        react_1.default.createElement(PerfilStyles_1.CheckboxStyled, null, "Eu permito que a 360 Su\u00EDtes armazene e processe meus dados pessoais.")))),
                            react_1.default.createElement(antd_1.Row, { justify: "space-between", align: "middle" },
                                react_1.default.createElement(antd_1.Col, { span: 24 },
                                    react_1.default.createElement(antd_1.Row, { justify: "end", align: "middle" },
                                        react_1.default.createElement(antd_1.Form.Item, null,
                                            react_1.default.createElement(antd_1.Button, { type: "primary", htmlType: "submit", className: "btn-save", onClick: onFinish }, `${isUpdate ? 'Atualizar' : 'Efetuar'} Pré Check-in`)))))))))),
        react_1.default.createElement(HomeFooter_1.default, null)));
};
exports.default = CheckIn;
